import { LessonsTab } from './LessonsTab'
import { DictionaryTab } from './DictionaryTab'
import { StagesTab } from './StagesTab'
import { CalendarTab } from './CalendarTab'
import { AttemptsTab } from './AttemptsTab'
import { ReviewQueueTab } from './ReviewQueueTab'
import { UsersTab } from './UsersTab'
import { TeamsTab } from './TeamsTab'
import { ReportsTab } from './ReportsTab'
import { SmsUsageTab } from './SmsUsageTab'
import { OnboardingTab } from './OnboardingTab'
import { NotificationsTab } from './NotificationsTab'
import { RewardsTab } from './RewardsTab'
import { SettingsTab } from './SettingsTab'

/**
 * The admin panel's tabs, in the order the header shows them (X1).
 *
 * A new tab is one row here plus its component under pages/admin/; the shell
 * (AdminShell.jsx) knows nothing else about it. Every tab is rendered with
 * the same props bag — `lessons`, `sorted`, `loading`, `view`, `onUpdate`,
 * `onCreated`, `onCancel` — and reads what it needs.
 */
export const TABS = [
  { id: 'lessons', label: 'درس‌ها', Component: LessonsTab },
  { id: 'dictionary', label: 'واژه‌نامه', Component: DictionaryTab },
  { id: 'stages', label: 'مراحل', Component: StagesTab },
  { id: 'calendar', label: 'تقویم', Component: CalendarTab },
  { id: 'attempts', label: 'تلاش‌ها', Component: AttemptsTab },
  { id: 'review', label: 'صف بررسی', Component: ReviewQueueTab },
  { id: 'users', label: 'کاربران', Component: UsersTab },
  { id: 'teams', label: 'تیم‌ها', Component: TeamsTab },
  { id: 'reports', label: 'گزارش', Component: ReportsTab },
  { id: 'sms-usage', label: 'مصرف پیامک', Component: SmsUsageTab },
  { id: 'onboarding', label: 'نمونه‌های آنبوردینگ', Component: OnboardingTab },
  { id: 'notifications', label: 'اعلان‌ها', Component: NotificationsTab },
  { id: 'rewards', label: 'جوایز', Component: RewardsTab },
  { id: 'settings', label: 'تنظیمات', Component: SettingsTab },
]
